import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function ProducView__loadingSkeleton() {
    return (
        <div className="col-12">
            <Skeleton count={1} height={20} width={170} style={{ marginBottom: 10 }} /> <br />

            <Skeleton count={1} height={35} width={300} style={{ marginBottom: 10 }} /> <br />

            <Skeleton count={1} height={25} width={100} style={{ marginBottom: 15 }} /> <br />

            <div className="d-flex" style={{ marginBottom: 20 }}>
                <div>
                    <Skeleton count={1} height={20} width={60} style={{ marginBottom: 10 }} /> <br />
                    <div className="d-flex">
                        <Skeleton count={1} height={40} width={100} style={{ marginBottom: 10, marginRight: 15 }} />
                        <Skeleton count={1} height={40} width={100} style={{ marginBottom: 10, marginRight: 15 }} />
                    </div>
                </div>

                <div>
                    <Skeleton count={1} height={20} width={70} style={{ marginBottom: 10 }} /> <br />
                    <div className="d-flex">
                        <Skeleton count={1} height={40} width={80} style={{ marginBottom: 10, marginRight: 15 }} />
                        <Skeleton count={1} height={40} width={80} style={{ marginBottom: 10, marginRight: 15 }} />
                    </div>
                </div>
            </div>

            <Skeleton count={1} height={55} width={"100%"} style={{ marginBottom: 15 }} />
        </div>
    )
}

export default memo(ProducView__loadingSkeleton)